import { ALL_CATEGORIES } from './constants.js';
const data = {};
export const registry = {
    getConsentCategories: async function (cookieName) {
        // fallback to require all consents to be on the safe side.
        return data[cookieName] ?? ALL_CATEGORIES;
    },
};
